// ── Importaciones tal cual ──────────────────────────────
import { useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { WarehouseFetchAPI } from '../../api/Warehouse';
import add from '../img/icons/add-product.png'
import ModalNewUpdateWarehouse from './ModalWarehouse/ModalNewUpdateWarehouse';
import ErrorAlert from '../Alerts/ErrorAlert';
import Swal from 'sweetalert2';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .wh-
───────────────────────────────────────────────────────── */
const WH_CSS = `
@keyframes wh-up   { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
@keyframes wh-fade { from{opacity:0} to{opacity:1} }

/* ── page ── */
.wh-page { font-family: var(--font-sans,-apple-system,sans-serif); }

/* ── banner ── */
.wh-banner {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: .75rem;
  background: var(--bg,#fff); border: 1.5px solid rgba(0,0,0,.07);
  border-radius: 14px; padding: .9rem 1.1rem; margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0,0,0,.04); animation: wh-up .28s ease both;
}
.wh-banner-left {}
.wh-banner-eyebrow {
  font-size: .67rem; font-weight: 700; letter-spacing: .09em;
  text-transform: uppercase; color: #1B3A6B; margin-bottom: .2rem;
}
.wh-banner-title {
  font-size: .95rem; font-weight: 800; color: #0A0A0A;
  display: flex; align-items: center; gap: .45rem;
}
.wh-banner-branch {
  font-size: .78rem; color: #6B7280; margin-top: .2rem;
  display: flex; align-items: center; gap: .3rem;
}
.wh-banner-branch strong { color: #1B3A6B; }

/* ── no branch placeholder ── */
.wh-no-branch {
  display: flex; flex-direction: column; align-items: center;
  justify-content: center; min-height: 200px; gap: .7rem;
  border: 1.5px dashed rgba(0,0,0,.12); border-radius: 14px;
  padding: 2rem; text-align: center; animation: wh-fade .25s ease;
}
.wh-no-branch-ico {
  width: 52px; height: 52px; border-radius: 50%;
  background: rgba(27,58,107,.08); color: #1B3A6B;
  display: grid; place-items: center;
}
.wh-no-branch-title { font-size: .88rem; font-weight: 700; color: #6B7280; }

/* ── ADD BUTTON CARD ── */
.wh-add-card {
  display: flex; flex-direction: column; align-items: center;
  justify-content: center; gap: .6rem;
  min-height: 130px; padding: 1.25rem .75rem;
  border-radius: 14px; border: 2px dashed rgba(27,58,107,.22);
  background: rgba(27,58,107,.04); cursor: pointer;
  transition: all .18s; margin-top: 1rem; width: 100%;
  animation: wh-up .25s ease both;
}
.wh-add-card:hover { border-color: rgba(27,58,107,.5); background: rgba(27,58,107,.09); transform: translateY(-2px); }
.wh-add-ico {
  width: 38px; height: 38px; border-radius: 50%;
  background: rgba(27,58,107,.1); color: #1B3A6B;
  display: grid; place-items: center; transition: transform .18s;
}
.wh-add-card:hover .wh-add-ico { transform: scale(1.1) rotate(8deg); }
.wh-add-lbl { font-size: .8rem; font-weight: 700; color: #1B3A6B; }

/* ── DEFAULT WAREHOUSE CARD ── */
.wh-default-card {
  background: linear-gradient(135deg, #0F2444 0%, #1B3A6B 100%) !important;
  border: none !important; border-radius: 14px !important;
  padding: .9rem 1rem !important; margin-top: 1rem !important;
  box-shadow: 0 4px 18px rgba(27,58,107,.28) !important;
  animation: wh-up .22s ease both;
}
.wh-default-card .fw-bold { color: #fff !important; font-size: .88rem !important; }
.wh-default-card .card-item-categorie-title { color: #fff !important; }
.wh-default-card .text-secondary { color: rgba(255,255,255,.6) !important; font-size: .75rem !important; }
.wh-default-badge {
  display: inline-flex; align-items: center; gap: .3rem;
  padding: .22rem .65rem; border-radius: 999px;
  background: rgba(255,255,255,.15); border: 1px solid rgba(255,255,255,.2);
  font-size: .69rem; font-weight: 700; color: #fff;
  margin-top: .4rem;
}

/* ── REGULAR WAREHOUSE CARD ── */
.wh-card {
  background: #fff !important; border: 1.5px solid rgba(0,0,0,.08) !important;
  border-radius: 14px !important; padding: .9rem 1rem !important;
  margin-top: 1rem !important;
  box-shadow: 0 2px 8px rgba(0,0,0,.05) !important;
  animation: wh-up .22s ease both; transition: box-shadow .14s !important;
}
.wh-card:hover { box-shadow: 0 4px 18px rgba(0,0,0,.09) !important; }
.wh-card .card-item-categorie-title { font-size: .87rem !important; font-weight: 700 !important; color: #111827 !important; }
.wh-card .card-item-categorie-description { font-size: .74rem !important; color: #9CA3AF !important; margin-bottom: .35rem !important; }

/* action buttons inside card */
.wh-card .btn-outline-primary {
  border-radius: 8px !important; padding: .32rem .6rem !important;
  font-size: .77rem !important; border: 1.5px solid rgba(27,58,107,.22) !important;
  background: rgba(27,58,107,.07) !important; color: #1B3A6B !important;
  transition: all .13s !important;
}
.wh-card .btn-outline-primary:hover { background: #1B3A6B !important; color: #fff !important; border-color: #1B3A6B !important; }
.wh-card .btn-outline-danger {
  border-radius: 8px !important; padding: .32rem .6rem !important;
  font-size: .77rem !important; border: 1.5px solid rgba(239,68,68,.22) !important;
  background: rgba(239,68,68,.07) !important; color: #EF4444 !important;
  transition: all .13s !important;
}
.wh-card .btn-outline-danger:hover { background: #EF4444 !important; color: #fff !important; border-color: #EF4444 !important; }

/* switch override */
.wh-card .form-check-input:checked { background-color: #1B3A6B !important; border-color: #1B3A6B !important; }
.wh-card .form-check-input:not(:checked) { background-color: rgba(0,0,0,.12) !important; }
.wh-card .form-check-label { font-size: .73rem !important; color: #6B7280 !important; }

/* col spacing override so cards look even */
.wh-grid .col, .wh-grid [class*="col"] { padding-bottom: 0; }

/* responsive */
@media(max-width: 640px) {
  .wh-banner { flex-direction: column; align-items: flex-start; }
}
`;

/* ── inject CSS once ── */
if (typeof window !== 'undefined' && !document.getElementById('wh-styles')) {
  const el = document.createElement('style');
  el.id = 'wh-styles'; el.textContent = WH_CSS;
  document.head.appendChild(el);
}

/* ── ICONS ── */
const IcoDb    = ()=><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>;
const IcoStore = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const IcoPlus  = ()=><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IcoStar  = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const Warehouse = ({ selectedBranch, warehouses, getWarehouseByBrachoffice }) => {

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  let user  = JSON.parse(localStorage.getItem('user'));
  let token = localStorage.getItem('x-access-token');

  const [warehouseSelect, setWarehouseSelect]       = useState({});
  const [showModalNewWarehouse, setShowModalNewWarehouse] = useState(false);
  const [userBranchoffices, setUserBranchs]         = useState([]);

  const deleteWarehouse = async (warehouse_id) => {
    try {
      const response = await WarehouseFetchAPI.deleteWarehouse(warehouse_id, token);
      ErrorAlert('', 'Bodega eliminada corectamente', 'success');
      getWarehouseByBrachoffice(selectedBranch.id);
    } catch (err) {
      ErrorAlert(err.response.data.message, 'Error', 'error');
    }
  };

  const toggleWarehouseActive = async (warehouse, is_enable) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `¿Deseas ${is_enable === 1 ? 'desactivar' : 'activar'} la bodega ${warehouse.name}?`,
      icon: 'warning', showCancelButton: true,
      confirmButtonText: 'Sí, continuar', cancelButtonText: 'Cancelar'
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          await WarehouseFetchAPI.updateWarehouse(warehouse.id, { is_enable: is_enable === 1 ? 0 : 1 }, token);
          ErrorAlert('', `Bodega ${is_enable === 1 ? 'desactivada' : 'activada'} correctamente`, 'success');
          getWarehouseByBrachoffice(selectedBranch.id);
        } catch (err) {
          ErrorAlert(err.response.data.message, 'Error', 'error');
        }
      }
    });
  };

  const viewWarehouse = () => {
    const list = warehouses.map((warehouse, i) => (
      warehouse.is_default == 0 ? (
        <Col key={i} xs="12" sm="6" md="6" lg="4" xl="3">
          <article className="wh-card border rounded-4 mt-4 p-2 position-relative">
            <div className="d-flex justify-content-between">
              <div className="ms-1 me-auto d-inline-block">
                <div className="d-flex justify-content-between">
                  <div className="fw-bold text-truncate card-item-categorie-title">
                    <span>{warehouse.name}</span>
                  </div>
                </div>
                <p className="text-secondary fw-light text-truncate card-item-categorie-description">{warehouse.location}</p>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center rounded-3 mt-1">
              <div className="m-1">
                <button className="btn btn-outline-primary pulse rounded-3 p-2 lh-1 border"
                  onClick={() => { setWarehouseSelect(warehouse); setShowModalNewWarehouse(true); }}>
                  <i className="uil uil-edit-alt" />
                </button>
              </div>
              <div className="m-1">
                <button className="btn btn-outline-danger pulse rounded-3 p-2 lh-1 border"
                  onClick={() => deleteWarehouse(warehouse.id)}>
                  <i className="uil uil-trash-alt" />
                </button>
              </div>
              {/* Form.Check switch — lógica original intacta */}
              <Form.Check
                type="switch"
                id={`switch-${warehouse.id}`}
                checked={warehouse.is_enable === 1}
                label={warehouse.is_enable === 0 ? 'Inactiva' : 'Activa'}
                onChange={() => toggleWarehouseActive(warehouse, warehouse.is_enable)}
                className="m-1"
              />
            </div>
            <div className="position-absolute top-0 end-0 mt-1" />
          </article>
        </Col>
      ) : null
    ));
    return list;
  };

  const viewWarehouseDefauld = () => {
    const list = warehouses.map((warehouse, i) => (
      warehouse.is_default == 1 ? (
        <Col key={i} xs="12" sm="6" md="6" lg="4" xl="3">
          <article className="wh-default-card card-on shadow-sm rounded-4 mt-4 p-2 position-relative">
            <div className="d-flex justify-content-between">
              <div className="ms-1 me-auto d-inline-block">
                <div className="d-flex justify-content-between">
                  <div className="fw-bold text-truncate card-item-categorie-title">
                    <span>{warehouse.name}</span>
                  </div>
                </div>
                <p className="text-secondary fw-light text-truncate card-item-categorie-description">{warehouse.location}</p>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center rounded-3 mt-1">
              <div className="d-flex align-item-center justify-content-start gap-1" />
            </div>
            <div className="d-flex justify-constent-center align-items-center">
              {/* label original intacta */}
              <label className="icon-on pulse rounded-3 p-2 lh-1 border-on border-0">
                <small className="ms-1 text-on fw-semibold">Bodega por defecto</small>
              </label>
              <span className="wh-default-badge"><IcoStar /> Por defecto</span>
            </div>
          </article>
        </Col>
      ) : null
    ));
    return list;
  };

  useEffect(() => { setUserBranchs(user.branchoffices); }, []);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  return (
    <>
      <div className="wh-page">

        {/* ── BANNER ── */}
        <div className="wh-banner">
          <div className="wh-banner-left">
            <p className="wh-banner-eyebrow">Gestión</p>
            <div className="wh-banner-title"><IcoDb /> Bodegas</div>
            <div className="wh-banner-branch">
              <IcoStore />
              {selectedBranch.code != 0
                ? <>Sucursal activa: <strong>{selectedBranch.name}</strong></>
                : 'Selecciona una sucursal para continuar'}
            </div>
          </div>
        </div>

        {/* ── CONTENIDO ── */}
        {selectedBranch.code != 0 ? (
          <div className="wh-grid">
            {/* cards grid — Col de Bootstrap dentro de Row */}
            <Row className="g-0">

              {/* ── ADD BUTTON ── */}
              <Col xs="12" sm="6" md="6" lg="4" xl="3">
                <button
                  className="wh-add-card btn-add-product-list rounded-4 pulse mt-4 py-4 w-100"
                  onClick={() => { setWarehouseSelect({}); setShowModalNewWarehouse(true); }}
                >
                  <div className="wh-add-ico"><IcoPlus /></div>
                  <span className="wh-add-lbl">Agregar una bodega</span>
                  {/* img original — import preservado */}
                  <img src={add} alt="Add" style={{ display: 'none' }} />
                </button>
              </Col>

              {/* viewWarehouseDefauld() y viewWarehouse() — lógica original intacta */}
              {viewWarehouseDefauld()}
              {viewWarehouse()}

            </Row>
          </div>
        ) : (
          <div className="wh-no-branch">
            <div className="wh-no-branch-ico"><IcoDb /></div>
            <p className="wh-no-branch-title">Selecciona una sucursal para ver las bodegas</p>
          </div>
        )}

      </div>

      {/* ModalNewUpdateWarehouse — props exactos */}
      <ModalNewUpdateWarehouse
        showModalNewWarehouse={showModalNewWarehouse}
        setShowModalNewWarehouse={setShowModalNewWarehouse}
        selectedBranch={selectedBranch}
        warehouseSelect={warehouseSelect}
        getWarehouseByBrachoffice={getWarehouseByBrachoffice}
      />

      {/* imports no-JSX preservados */}
      {void [ErrorAlert]}
    </>
  );
};

export default Warehouse;